// Runs a vendor script's source in the global scope, the way the old
// `script-loader` package did. `source` is the raw text of the file, obtained
// via a `?raw` import (webpack `asset/source`).
//
// `exports`, `module` and `define` are declared as parameters and left
// undefined so UMD vendor scripts detect no CommonJS/AMD environment and fall
// through to their global-registration branch (e.g. `window.jstz = ...`)
// instead of attaching to a module export. `this` is bound to `window` for the
// same reason. This reproduces script-loader's behavior with no extra deps.
module.exports = function runGlobalScript (source) {
  // eslint-disable-next-line no-new-func
  new Function('exports', 'module', 'define', source).call(window)
}
